/**
 * The narrowest viewport Spotlight Studio supports (PRODUCT.md: desktop-only, ≥1280px).
 *
 * The number is validated by the Studio's own geometry rather than picked from a device
 * chart: 72px rail + 280px left panel + 320px right panel = 672px of fixed chrome, plus
 * 80px of canvas padding, plus a 360px story frame at full scale = 1112px to show one
 * complete frame without horizontal scrolling. 1280 clears that with ~168px of slack.
 *
 * Applied as `min-width` on both app shells. Below it the document scrolls horizontally,
 * which is the honest failure mode: the Studio root is `overflow: hidden` and its panels
 * are `flex-shrink: 0`, so without this the right panel would simply be clipped away with
 * no scrollbar and no way to reach it.
 */
export const APP_MIN_WIDTH = 1280;
